import Footer from '../Footer';
import Header from '../Header';
import MobileNavigation from '../MobileNavigation';
import P2PEHero from '../img/P2PEHero.png';
import '../features/p2pe.scss';
import "../App.css";
import ShieldCheck from '../img/ShieldCheck.svg';
import Clipboard from '../img/Clipboard.svg';
import Lock from '../img/Lock.svg';
import Headset from '../img/Headset.svg';
import P2PEDataFlow from '../img/P2PEDataFlow.svg';
import { useGSAP } from '@gsap/react';
import { useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Link } from 'react-router-dom';
gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);


export default function P2PE() {
  const container = useRef();
 
  return (
    <>
      <main ref={container} style={{backgroundColor: '#000066', justifyContent: 'center' }}>
        <Header />
        <MobileNavigation />
        {/* HERO */}
        <div className="p2pe-hero">
            <div className="container">
                <h1 className="!mb-5 text-white large">Point-to-Point
                  Encryption</h1>
              <p className="protect-payment-data">
                Protect payment data from the moment a customer initiates a transaction.
              </p>
              <p className="encrypts">
                Every transaction starts with trust- and your customers
                expect nothing less. Point-to-Point Encryption (P2PE) removes
                sensitive card data from your systems by encrypting it at the device
                and keeping it protected until it reaches a secure environement.
              </p>
              <Link to="/bookDemo" className="button button-primary has-arrow has-arrow-white">
              Book a Demo
              </Link>
            </div>
           <img className="p2pe-hero-img" alt="Hero" src={P2PEHero} />
          </div>
        {/* SECTION 1: P2PE Data Flow Diagram (How it works) */}
        <div className="how-it-works">
          <img
            className="basys-data-flow"
            alt="Basys data flow"
            src={P2PEDataFlow}
          />
        </div>
        {/* SECTION 2 PAYMENT TYPES */}
        <div className="payment-types">
          <div className="frame">
            <div className="div">
              <h1>Stronger security from the start.</h1>
              <h1>Simpler PCI every day.</h1>
            </div>
            <p className="helps-protect">
              P2PE helps protect customer payment data while reducing the burden of
              handling sensitive information. Businesses benefit from stronger
              security controls, reduced PCI scope, and added confidence that card
              data remains protected throughout the transaction lifecycle.
            </p>
          </div>
          <div className="container">
            <div className="container-2">
              <div className="div-2">
                <div className="vector-wrapper">
                  <img className="vector" alt="Vector" src={ShieldCheck} />
                </div>
                <p className="text-wrapper-3">Protect Data at the Source</p>
              </div>
              <div className="paragraph">
                <p className="p">
                  Card data encrypted at the terminal, never touching your systems.
                </p>
              </div>
            </div>
            <div className="container-3">
              <div className="div-2">
                <div className="vector-wrapper">
                  <img className="vector" alt="Vector" src={Lock} />
                </div>
                <div className="text-wrapper-3">Reduced Risk &amp; Liability</div>
              </div>
              <div className="paragraph">
                <p className="p">
                  Strengthen security and minimize the potential impact of a breach.
                </p>
              </div>
            </div>
            <div className="container-4">
              <div className="div-2">
                <div className="vector-wrapper">
                  <img className="vector-2" alt="Vector" src={Clipboard} />
                </div>
                <div className="text-wrapper-3">Flexible, Supported Setup</div>
              </div>
              <div className="paragraph">
                <p className="p">
                  Multiple P2PE-ready devices backed by Basys experts.
                </p>
              </div>
            </div>
            <div className="container-5">
              <div className="div-2">
                <div className="vector-wrapper">
                  <img className="vector-3" alt="Vector" src={Headset} />
                </div>
                <div className="text-wrapper-3">Simplify PCI Compliance</div>
              </div>
              <div className="paragraph">
                <p className="p">
                  Reduce the number of systems in scope and streamline audits.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* SECTION 3 FINAL CTA*/}
        <div className="final-CTA">
          <h1>Ready to simplify security?</h1>
          <p className="learn-how-can">
            Learn how P2PE can help protect customer data, reduce compliance
            complexity, and support your business with secure payment processing.
          </p>
          <Link to="/bookDemo" className="button button-primary has-arrow has-arrow-white">
            Book a Demo
          </Link>
          <div className="container" />
          <div className="container-2" />
   
        </div>
      </main>
      <Footer />
    </>
  );
}
